import DOMPurify from 'dompurify';

const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'strong', 'a', 'br', 'i', 'hr',
  'ol', 'ul', 'li', 'p', 'u',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'colgroup', 'col'];
const allowedAttributes = ['href', 'target', 'rel', 'border', 'cellpadding',
  'cellspacing', 'summary', 'width', 'align', 'valign', 'bgcolor', 'colspan', 'rowspan',
  'height', 'nowrap', 'span'];

export const sanitizeHTML = (dirty: string) => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes
  });
};